// CONTRACT:C4-DESIGN-TOKENS.1.0
/** DEV-ONLY persona-impersonation gate (PURE).
 *
 *  The lower-left PROFILE control (PersonaSwitcher) exposes a "switch to any persona" roster — a
 *  DEVELOPMENT affordance for one-click local login as any seeded identity. That roster must NEVER
 *  let a REAL logged-in operator assume arbitrary clearances. The only signal of "this is a dev /
 *  local environment" available to the client is whether the dev-identities endpoint
 *  (`/api/dev-identities`) returned a roster:
 *    - LOCAL / DEV: the endpoint serves the seeded identities → the roster is offered (keep the
 *      one-click dev login).
 *    - PROD: the edge SEALS the endpoint (404), so the fetch yields an EMPTY list → the roster is
 *      withheld and the popover shows ONLY the current identity + sign-out.
 *
 *  This is DEFENSE-IN-DEPTH: even if the edge seal were ever misconfigured and the endpoint leaked,
 *  the client still gates the impersonation UI on an explicit, testable predicate rather than
 *  rendering a roster by default. PURE + exported so it is unit-tested directly. */
export function canImpersonate(devIdentities: ReadonlyArray<unknown>): boolean {
  return devIdentities.length > 0;
}
